import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { selectProfileResidenceResponse } from '../../store/selectors/profile.selectors';
import { selectCustomerProfileIncome } from '../../../customer-attributes/store/customer-attributes.selector';

export interface TabNav {
  label: string;
  link: string;
  refreshRequired?: boolean;
}

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit, OnDestroy {
  profileNav: TabNav[] = [
    { label: 'Income', link: 'income' },
    { label: 'Residence', link: 'residence' },
  ];
  unsubscribe$ = new Subject();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    combineLatest([this.store.select(selectCustomerProfileIncome), this.store.select(selectProfileResidenceResponse)])
      .pipe(
        filter(([income, residence]) => !!income && !!residence),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(([income, residence]) => {
        const incomeRefreshRequired = income?.isCustomerIncomeAttributeRefreshRequired;
        const currentDate = new Date();
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(currentDate.getFullYear() - 1);

        const residenceRefreshRequired = residence
          ? residence.some((item) => new Date(item.insertTs) < oneYearAgo) || residence.length === 0
          : false;

        this.profileNav = [
          { label: 'Income', link: 'income', refreshRequired: incomeRefreshRequired },
          { label: 'Residence', link: 'residence', refreshRequired: residenceRefreshRequired },
        ];
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
